module.exports = __webpack_public_path__ + "images/sprites/ui/review_star_bg_fd7d6e0cc90d370ad7b7e64b3a796cc2.png";